import { render } from "./Share.vue?vue&type=template&id=d72d14a2&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=d72d14a2&lang=less"
import "./Share.vue?vue&type=style&index=1&id=d72d14a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72d14a2"]])

export default __exports__